<template>
  <div v-if="order">
    <modalWindow v-model="show" @ok="createSubmit()" @cancel="cancel()" @closed="onClose()" :title="order.customer.companyName + ' - ' + order.date.format('DD.MM.YYYY')" cancelText="Zrušïť" okText="Uložiť">

      <form>
        <div class="row" v-if="hasSomeRole(['DEALER', 'DEALER_L2'])">
          <div class="col-md-12">
            <table class="table table-hover">
              <thead>
              <tr>
                <th style="min-width: 200px;"></th>
                <th>Objednané</th>
                <th>Vratka</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in order.items">
                <td class="form-label" :title="item.product.shortDescription">{{ item.product.label }}</td>
                <td>
                  <number-field
                    v-model="item.amount"
                    :field-id="'amount' + index"
                    :step="1"
                    :min="0"
                    validation="required|numeric|min_value:0"></number-field>
                </td>
                <td>
                  <number-field
                    v-model="item.returns"
                    :field-id="'returns' + index"
                    :step="1"
                    :min="0"
                    validation="required|numeric|min_value:0"></number-field>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr v-if="hasSomeRole(['DEALER', 'DEALER_L2'])" />
        <div class="row" v-if="hasSomeRole(['DEALER', 'DEALER_L2'])">
          <div class="col-md-4">
            <text-field
              field-id="cash"
              label="Hotovosť (€)"
              v-model="order.cash"
              :maxlength="11"
              validation="decimal2:2|min_value2:0.01"></text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <text-area-field field-id="note"
                             v-model.trim="order.note"
                             label="Poznámka"
                             :maxlength="300"
                             validation="max:300"
                             css-class="note"></text-area-field>
          </div>
        </div>
      </form>
    </modalWindow>
  </div>
</template>

<script>
  import _ from 'lodash';
  import { mapGetters } from 'vuex';
  import modal from 'vue-strap/src/Modal';
  import validationMixin from 'components/validationMixin';
  import textField from 'components/form/textField';
  import numberField from 'components/form/numberField';
  import dateField from 'components/form/dateField';
  import selectField from 'components/form/selectField';
  import textAreaField from 'components/form/textAreaField';
  import { LOCALE } from 'config'
  import notificationService from 'services/notificationService';

  export default {
    components: {modalWindow: modal, textField, numberField, dateField, selectField, textAreaField},
    mixins: [validationMixin],
    data: () => ({
      show: false,
      order: null,
      showAdd: false
    }),
    computed: {
      ...mapGetters({
        hasSomeRole: 'auth/hasSomeRole'
      })
    },
    props: {
      showModel: {
        type: Boolean,
        default () {
          return false;
        }
      },
      model: {
        type: Object
      }
    },
    methods: {
      editMode() {
        return !!this.order.id;
      },
      createSubmit() {
        this.protect();
        this.$validator.validateAll().then((res) => {
          if (res) {
            let operation;
            if (this.editMode()) {
              operation = 'order/update';
            } else {
              operation = 'order/create';
            }

            const order = _.cloneDeep(this.order);
            _.remove(order.items, {amount: 0, returns: 0});
            if (order.cash && _.isString(order.cash)) {
              order.cash = parseFloat(order.cash.replace(',','.'))
            }
            this.$store.dispatch(operation, order).then((result) => {
              if (result) {
                notificationService.success('Objednávka bola uložená.');
                this.$emit('close');
              }
            }).catch(this.unprotect);
          } else {
            this.unprotect();
          }
        }).catch(this.unprotect);
      },
      deleteItem(itemToDelete) {
        this.order.items = _.reject(this.order.items, (item) => item.product.id === itemToDelete.product.id);
      },
      clear() {
        this.unprotect();
        this.$nextTick(() => {
          this.errors.clear();
        });
      },
      cancel() {
        this.$emit('close');
      },
      onClose() {
        this.clear();
      }
    },
    watch: {
      model (model) {
        if (model) {
          this.order = model;

          let someAdded = false;
          this.$store.getters['product/validItems'].forEach(product => {
            if (_.every(model.items, (item) => item.product.id !== product.id)) {
              model.items.push({product, amount: 0, returns: 0});
              someAdded = true;
            }
          });

          if (someAdded) {
            model.items.sort((item1, item2) => item1.product.label.localeCompare(item2.product.label, LOCALE));
          }

          this.clear();
        }
      },
      showModel(showModel) {
        this.show = showModel;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/orderCreateModal.vue